<app-price-calculaor-common [tagSelecter]="tag"  [tagData]="tagData" *ngIf="tagData.length && !tracking"></app-price-calculaor-common>